import { render, staticRenderFns } from "./PopupStaffAdd.vue?vue&type=template&id=29f29bfc&scoped=true&"
import script from "./PopupStaffAdd.vue?vue&type=script&lang=js&"
export * from "./PopupStaffAdd.vue?vue&type=script&lang=js&"
import style0 from "./PopupStaffAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f29bfc",
  null
  
)

export default component.exports